export interface IMetricDataPayload {
  data: IMetricData;
  hasFailed: boolean;
  isLoadingCompleted: boolean;
}

export interface IMetricData {
  dates: string[];
  metricGroups: IMetricGroup[];
}

export interface IMetricGroup {
  name: string;
  nameStringKey: string;
  metrics: IMetric[];
}

export interface IMetric {
  name: string;
  nameStringKey: string;
  shortNameStringKey?: string;
  shouldTrendDown?: boolean;
  valueType: MetricValueType;
  tooltipTextStringKey: string;
  values: Record<string, number>;
  stringValues: Record<string, string>;
  moMValues: Record<string, number>;
}

export enum MetricValueType {
  Numeric = 0,
  Percentage = 1
}

